/**
 * SKE-4790. Refresh the campaign surfaces after an account is reconnected
 * somewhere other than the campaign page.
 *
 * The banner, the sidebar entry and the calendar cutover marker all read one
 * react-query cache with a five minute `staleTime`, and the global client does
 * not refetch on focus. Until SKE-4790 the only invalidation lived in the
 * campaign's own authorisation pass, so a customer who updated an account from
 * Manage Accounts kept being told to update it. In the final week, where the
 * banner is red and cannot be dismissed, that reads as the update having
 * failed.
 *
 * Deliberately not a hook: the reconnect paths that need it are redux thunks,
 * and `api/query-client` is exported precisely so non-React code can invalidate.
 */
import { queryClient } from "../../api/query-client";
import { INSTAGRAM_CAMPAIGN_QUERY_KEY } from "./use-campaign-status";

export function refreshInstagramCampaignStatus(): void {
  void queryClient.invalidateQueries({
    queryKey: INSTAGRAM_CAMPAIGN_QUERY_KEY,
  });
}
